<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete dokument:</p>
      <p class="filename">{{ document.file_name }}</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deleteDocument"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['document']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getDocumentForCommunity']),
    deleteDocument() {
      if (this.loading) {
        return;
      }

      let deleteRequest = {
        media_id: this.document.id,
        member_id: this.$store.getters.getActiveCommunity.member_id
      };

      this.loadingStarted();
      axios
        .post(
          `/community/${
            this.$store.getters.getActiveCommunity.id
          }/community-document/delete`,
          deleteRequest
        )
        .then(async () => {
          await this.getDocumentForCommunity(this.$route.params.id);
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(e => {
          console.log('eer', e);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.filename {
  word-break: break-word;
}
</style>
